var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.465,
    height: 25.359,
    viewBox: "0 0 25.465 25.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "moon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    fill: "#c7c7c7",
    d: "M24.846 15.1a.9.9 0 0 0-.749.163 9.554 9.554 0 0 1-2.9 1.693 9.075 9.075 0 0 1-3.289.586 9.561 9.561 0 0 1-9.572-9.57 10.036 10.036 0 0 1 .521-3.159 8.744 8.744 0 0 1 1.563-2.8.831.831 0 0 0-.13-1.173.9.9 0 0 0-.749-.163A13.14 13.14 0 0 0 2.638 5.3a12.893 12.893 0 1 0 22.794 10.812.79.79 0 0 0-.586-1.012z",
    "data-name": "Path 908",
    transform: "translate(0 -.652)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.f7ec4a37c1ec64f35e79430c3c562dfb.svg";
export { ForwardRef as ReactComponent };